import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "bar-charts"
};
var _hoisted_2 = {
  class: "bar-charts-content"
};
var _hoisted_3 = {
  class: "bar-charts-content-item margin-r10"
};
var _hoisted_4 = {
  class: "bar-charts-content-item"
};
var _hoisted_5 = {
  key: 0,
  class: "charts-empty"
};
import { computed, watch } from 'vue';
import { useCharts } from '@/hooks/setCharts';
import { chartsOption } from './chartsOption';
export default {
  __name: 'ReportCharts',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    // 达标验收统计数据
    data: {
      type: Object,
      default: function _default() {}
    },
    type: {
      // 类型
      type: String,
      default: 'person'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useCharts = useCharts({
        id: 'myChart'
      }),
      initCharts = _useCharts.initCharts,
      setOption = _useCharts.setOption,
      setLoading = _useCharts.setLoading,
      chartInstance = _useCharts.chartInstance;
    // 分数向上取整
    var statisticalData = computed(function () {
      return {
        currentPeriodSumScore: props.data ? Math.ceil(props.data.currentPeriodSumScore) : '--',
        allPeriodAvgScore: props.data ? Math.ceil(props.data.allPeriodAvgScore) : '--'
      };
    });
    // 监听状态切换
    watch(function () {
      return props.loading;
    }, function (val) {
      setLoading(val);
    });
    // 监听周期切换
    watch(function () {
      return props.data;
    }, function () {
      if (!chartInstance) {
        initCharts();
      }
      setOption(chartsOption);
    });
    return function (_ctx, _cache) {
      var _statisticalData$valu, _statisticalData$valu2, _props$data;
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "bar-charts-title"
      }, "达标验收", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString((_statisticalData$valu = statisticalData.value) === null || _statisticalData$valu === void 0 ? void 0 : _statisticalData$valu.currentPeriodSumScore), 1), _cache[0] || (_cache[0] = _createElementVNode("span", null, "该周期总分数", -1))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString((_statisticalData$valu2 = statisticalData.value) === null || _statisticalData$valu2 === void 0 ? void 0 : _statisticalData$valu2.allPeriodAvgScore), 1), _cache[1] || (_cache[1] = _createElementVNode("span", null, "全周期平均总分数", -1))])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "charts-wrap"
      }, [_createElementVNode("div", {
        id: "myChart",
        class: "charts"
      })], -1)), !__props.loading && !((_props$data = props.data) !== null && _props$data !== void 0 && (_props$data = _props$data.histogram) !== null && _props$data !== void 0 && _props$data.length) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]);
    };
  }
};